<template>
	<div class="change-info-wrapper">
		<div class="form-card">
			<h3 class="form-title">更新个人信息</h3>
			<el-form ref="selfInfoForm" :model="selfInfoForm" :rules="selfInfoRules" label-width="100px"
				class="modern-form" label-position="left">
				<el-form-item label="头像">
					<div class="avatar-display">
						<div v-if="selfInfoForm.sex === '2'" class="avatar-wrapper">
							<img src="@/assets/girl.png" alt="头像" class="avatar-img">
						</div>
						<div v-else class="avatar-wrapper">
							<img src="@/assets/boy.png" alt="头像" class="avatar-img">
						</div>
					</div>
				</el-form-item>
				<el-form-item label="姓名" prop="username">
					<el-input v-model="selfInfoForm.username" placeholder="请输入姓名" class="form-input"></el-input>
				</el-form-item>
				<el-form-item label="邮箱" prop="email">
					<el-input v-model="selfInfoForm.email" placeholder="请输入邮箱" class="form-input"></el-input>
				</el-form-item>
				<el-form-item label="手机号码" prop="userPhone">
					<el-input v-model="selfInfoForm.userPhone" placeholder="请输入手机号" class="form-input"></el-input>
				</el-form-item>
				<el-form-item label="性别" prop="sex">
					<el-select v-model="selfInfoForm.sex" placeholder="请选择性别" class="form-input">
						<el-option label="保密" value="0"></el-option>
						<el-option label="男" value="1"></el-option>
						<el-option label="女" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="年龄" prop="age">
					<el-input-number v-model="selfInfoForm.age" :min="1" :max="100" class="form-input-number"></el-input-number>
				</el-form-item>
				<el-form-item class="form-actions">
					<el-button type="primary" @click="onSubmit('selfInfoForm')" class="submit-btn">提交</el-button>
					<el-button class="cancel-btn">取消</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import {changeSelfInfo} from "@/api/index.js"
	export default {
		props: {
			userInfo: {
				type: Object,
				default () {
					return {}
				}
			}
		},
		watch: {
			userInfo: {
				handler: function(n, o) {
					this.selfInfoForm = this.userInfo;
				},
				deep: true
			}
		},
		data() {
			var checkEmail = (rule, value, callback) => {
				const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
				if (!value) {
					return callback(new Error('邮箱不能为空'))
				}
				setTimeout(() => {
					if (mailReg.test(value)) {
						callback()
					} else {
						callback(new Error('请输入正确的邮箱格式'))
					}
				}, 100)
			};
			var checkPhone = (rule, value, callback) => {
				const phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/
				if (!value) {
					return callback(new Error('电话号码不能为空'))
				}
				setTimeout(() => {
					// Number.isInteger是es6验证数字是否为整数的方法,实际输入的数字总是识别成字符串
					// 所以在前面加了一个+实现隐式转换

					if (!Number.isInteger(+value)) {
						callback(new Error('请输入数字值'))
					} else {
						if (phoneReg.test(value)) {
							callback()
						} else {
							callback(new Error('电话号码格式不正确'))
						}
					}
				}, 100)
			};
			var checkAge = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('必填项不能为空'))
				}
				setTimeout(() => {
					// Number.isInteger是es6验证数字是否为整数的方法,实际输入的数字总是识别成字符串
					// 所以在前面加了一个+实现隐式转换

					if (value > 100) {
						callback(new Error('年龄不能大于100'))
					} else {
						callback()
					}
				}, 100)
			}
			return {
				selfInfoForm: {
					id:"",
					imageUrl: "",
					username: "小徐",
					email: "123123@qq.com",
					userPhone: "11311231123",
					sex: "1",
					age: 20,
					// birthday: new Date()
				},
				selfInfoRules: {
					// imageUrl: [{
					// 	required: true,
					// 	message: '请输入名字',
					// 	trigger: 'blur'
					// }],
					username: [{
							required: true,
							message: '请输入名字',
							trigger: 'blur'
						},
						{
							min: 2,
							message: '长度大于2个字符',
							trigger: 'blur'
						}
					],
					email: [{
						required: true,
						message: '请输入邮箱',
						trigger: 'blur'
					}, {
						validator: checkEmail,
						trigger: 'blur'
					}],
					userPhone: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}, {
						validator: checkPhone,
						trigger: 'blur'
					}],
					sex: [{
						required: true,
						message: '请选择性别',
						trigger: 'change'
					}],
					age: [{
						required: true,
						message: '请输入年龄',
						trigger: 'blur'
					}, {
						validator: checkAge,
						trigger: 'blur'
					}]
				}
			}
		},
		methods: {
			onSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$prompt('请输入密码', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(({
							value
						}) => {
							this.selfInfoForm.password = value;
							this.selfInfoForm.loginAccount = localStorage.getItem("username")
              this.selfInfoForm.createTime =null
							// console.log(this.selfInfoForm)
							changeSelfInfo(this.selfInfoForm).then(res => {
								// console.log(res);
								if(res.code == "0000"){
									this.$message.success("修改成功")
									this.$emit("successChange")
								}
							})
							// this.$message({
							// 	type: 'success',
							// 	message: '你的邮箱是: ' + value
							// });
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '取消输入'
							});
						});
					} else {
						return false;
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
.change-info-wrapper {
	padding: 0 30px;
}

.form-card {
	background: #FFFFFF;
	border-radius: 8px;
	padding: 30px;
}

.form-title {
	font-size: 18px;
	color: #303133;
	margin: 0 0 25px 0;
	font-weight: 500;
	padding-left: 12px;
	border-left: 3px solid #409EFF;
}

.modern-form {
	max-width: 600px;
}

.modern-form ::v-deep .el-form-item {
	margin-bottom: 24px;
}

.modern-form ::v-deep .el-form-item__label {
	font-size: 14px;
	color: #606266;
	font-weight: 400;
}

.avatar-display {
	display: flex;
	align-items: center;
}

.avatar-wrapper {
	width: 60px;
	height: 60px;
	border-radius: 50%;
	background: #F0F7FF;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	border: 2px solid #E8F4FF;
}

.avatar-img {
	width: 45px;
	height: 45px;
	object-fit: cover;
}

.form-input {
	width: 400px;
}

.form-input ::v-deep .el-input__inner {
	height: 40px;
	line-height: 40px;
	border-radius: 6px;
	border: 1px solid #DCDFE6;
	transition: all 0.3s ease;

	&:hover {
		border-color: #C0C4CC;
	}

	&:focus {
		border-color: #409EFF;
		box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
	}
}

.form-input ::v-deep .el-input__inner::placeholder {
	color: #C0C4CC;
	font-size: 14px;
}

.form-input-number ::v-deep .el-input-number {
	width: 400px;
}

.form-input-number ::v-deep .el-input__inner {
	height: 40px;
	line-height: 40px;
	border-radius: 6px;
}

.form-actions {
	margin-top: 30px;
}

.submit-btn {
	width: 120px;
	height: 40px;
	background: linear-gradient(135deg, #67B3FF 0%, #409EFF 100%);
	border: none;
	border-radius: 6px;
	font-size: 15px;
	transition: all 0.3s ease;

	&:hover {
		box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
		transform: translateY(-2px);
	}

	&:active {
		transform: translateY(0);
	}
}

.cancel-btn {
	width: 120px;
	height: 40px;
	border-radius: 6px;
	font-size: 15px;
	color: #606266;
	border: 1px solid #DCDFE6;
	background: #FFFFFF;
	transition: all 0.3s ease;

	&:hover {
		color: #409EFF;
		border-color: #C6E2FF;
		background: #ECF5FF;
	}
}
</style>
